import React from 'react';
import Framework from "@beardeddevops/react.framework";
import {Collections, Parts} from "components";

const breadcrumbsStatic = [{
	name: 'Help Desks',
	url: '/helpdesks',
	icon: 'comments'
}];

class WoClearCodes extends Framework.Components.View {
	constructor(props) {
		super(props);
	}

	render() {
		let {history, roles} = this.props;

		let breadcrumbs = breadcrumbsStatic.slice().concat([
			{
				name: "Clear Codes",
				url: `/helpdesks/overrides`,
				icon: 'laptop',
			}
		]);

		return (
			<div className={'container-fluid'}>
				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={history}/>

				<Parts.Tickers.HelpdeskTicker/>

				<Collections.WoClearCodes
					history={history}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					roles={roles}
				/>
			</div>

		)
	}
}

export default Framework.Components.withRootState(WoClearCodes);
